import { Box, CircularProgress } from '@mui/material';

const ReactLazyLoading = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        position: 'relative',
        minHeight: 0,
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <CircularProgress />
    </Box>
  );
};
export default ReactLazyLoading;
